export const getFetcher = async <T extends unknown>(
  url: string,
): Promise<T> => {
  try {
    const res = await fetch(`${url}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    return await res.json();
  } catch (error) {
    throw error;
  }
};
